import React, { useEffect, useState } from 'react';
import './widget.css';
import { initData, handleKeyUp, resetSession, toggleLanguage, selectMode, applySuggestion } from './chatUI.js';
import { sendMessage } from './messageHandler.js';

export default function CustomChatWidgetV2({ isAuthenticated, isRestrictedClass }) {
  const [isOpen, setIsOpen] = useState(false);
  const shellClassName = isRestrictedClass ? 'qb-chat-shell-right' : 'qb-chat-shell-left';
  const widgetPositionStyle = isRestrictedClass
    ? { right: '20px', left: 'auto', bottom: '90px' }
    : { left: '20px', right: 'auto', bottom: '90px' };

  useEffect(() => {
    if (!isAuthenticated) {
      setIsOpen(false);
      return undefined;
    }

    const previousGlobals = {
      selectMode: window.selectMode,
      sendMessage: window.sendMessage,
      toggleLanguage: window.toggleLanguage,
      resetSession: window.resetSession,
      applySuggestion: window.applySuggestion,
    };

    window.selectMode = selectMode;
    window.sendMessage = sendMessage;
    window.toggleLanguage = toggleLanguage;
    window.resetSession = resetSession;
    window.applySuggestion = applySuggestion;

    initData();

    return () => {
      window.selectMode = previousGlobals.selectMode;
      window.sendMessage = previousGlobals.sendMessage;
      window.toggleLanguage = previousGlobals.toggleLanguage;
      window.resetSession = previousGlobals.resetSession;
      window.applySuggestion = previousGlobals.applySuggestion;
    };
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className={shellClassName}>
      <button
        className="qb-chat-launcher"
        type="button"
        onClick={() => setIsOpen((value) => !value)}
        aria-label="Toggle V2 chat widget"
      >
        💬
      </button>

      <div className="qb-chat-widget" style={{ display: isOpen ? 'flex' : 'none', ...widgetPositionStyle }}>
        <div className="qb-chat-header">
          <div className="qb-chat-header-left">
            <div className="qb-chat-title">ReadSphereGPT</div>
          </div>
          <div className="qb-chat-header-right">
            <button
              id="lang-toggle-btn"
              className="qb-chat-lang-dot"
              type="button"
              onClick={toggleLanguage}
              aria-label="Toggle output language"
              title="Output Language"
            >
              🌐
            </button>
            <button className="qb-chat-reset-btn" type="button" onClick={resetSession}>
              Reset
            </button>
            <button className="qb-chat-close-btn" type="button" onClick={() => setIsOpen(false)} aria-label="Close V2 chat widget">
              ✕
            </button>
          </div>
        </div>

        <div className="qb-chat-messages-area" id="messages-area">
          <div className="msg bot" id="main-msg">System initializing...</div>
        </div>

        <div className="qb-chat-status-bar" id="data-status">
          Please select a mode to start.
        </div>

        <div className="input-box" id="input-container">
          <div id="suggestion-box" className="suggestion-box"></div>
          <input
            id="user-input"
            type="text"
            placeholder="Type @ to use a command..."
            onKeyUp={handleKeyUp}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                sendMessage();
              }
            }}
          />
          <button id="send-btn" type="button" onClick={sendMessage}>
            Send
          </button>
        </div>
      </div>
    </div>
  );
}